import axiosInstance from '../../../../../config/axiosConfig'
import { urlConfig } from '../../../../../config/apiConfig'
import React, { useContext, useState } from 'react'
import {
    Card,
    CardContent,
    Grid,
    IconButton,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { AlertContext } from '../../../../../context/AlertContext'
import { useAuth } from '../../../../../hook/useAuth'
import CustomModal from '../../../../common/popup/CustomModal'
import ActionButtons from '../../../../common/popup/ActionButtons'

export default function ParamsTable({ device, handleAlert }) {
    const { handleOpen } = useContext(AlertContext)
    const { auth } = useAuth()

    const [open, setOpen] = useState(false)
    const [input, setInput] = useState({
        min_y: '',
        max_y: '',
    })
    const [loading, setLoading] = useState(false)

    const handleUpdateShowGraph = async (item) => {
        try {
            const payload = {
                parameter_id: item.parameter_id,
                show_graph: item.show_graph === true ? false : true,
            }
            const resp = await axiosInstance.put(
                `${urlConfig.deviceIot}/show-graph/${device.device_id}`,
                payload,
            )
            if (resp.data.status === 200) {
            }
        } catch (error) {
            handleOpen({
                open: true,
                message: `${error.response?.data.message}`,
                isSuccess: false,
            })
        }
    }
    const handleUpdateLimit = async () => {
        setLoading(true)
        try {
            const body = {
                min_y: Number(input.min_y) || 0,
                max_y: Number(input.max_y) || 0,
                min_x: 0,
                max_x: 0,
                parameter_id: input.parameter_id,
            }

            const res = await axiosInstance.put(
                `${urlConfig.deviceIot}/min-max-graph/${device.device_id}`,
                body,
            )
            handleAlert('Setting saved successfully.', 'success')
        } catch (error) {
            const err = error.response?.data?.message
            handleAlert(`Failed to save setting. ${err}`, 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            {device?.params?.map((item, index) => (
                <React.Fragment key={index}>
                    {item.status && (
                        <Card
                            key={index}
                            sx={{
                                p: 1.5,
                                mb: 2,
                                borderRadius: 2,
                                border: '2px solid #ccc',
                                boxShadow: 0,
                                position: 'relative',
                            }}
                        >
                            {auth?.group === 'Admin' && (
                                <Stack
                                    direction={'row'}
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 5,
                                    }}
                                >
                                    <Tooltip title='Show Graph'>
                                        <IconButton
                                            onClick={() =>
                                                handleUpdateShowGraph(item)
                                            }
                                        >
                                            {/* {item.show_graph.toString()} */}
                                            {item.show_graph === true ? (
                                                <svg
                                                    width='24'
                                                    height='24'
                                                    viewBox='0 0 24 24'
                                                    fill='none'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        fillRule='evenodd'
                                                        clipRule='evenodd'
                                                        d='M3 21V2H1V22C1 22.5523 1.44772 23 2 23H22V21H3Z'
                                                        fill='#C8342F'
                                                    />
                                                    <path
                                                        fillRule='evenodd'
                                                        clipRule='evenodd'
                                                        d='M22.7072 6.70718L16.7072 12.7072C16.3167 13.0977 15.6835 13.0977 15.293 12.7072L14.0001 11.4143L9.70718 15.7072C9.31666 16.0977 8.68349 16.0977 8.29297 15.7072L6.00008 13.4143L2.70718 16.7072L1.29297 15.293L5.29297 11.293C5.68349 10.9024 6.31666 10.9024 6.70718 11.293L9.00008 13.5859L13.293 9.29297C13.6835 8.90244 14.3167 8.90244 14.7072 9.29297L16.0001 10.5859L21.293 5.29297L22.7072 6.70718Z'
                                                        fill='#C8342F'
                                                    />
                                                </svg>
                                            ) : (
                                                <svg
                                                    width='24'
                                                    height='24'
                                                    viewBox='0 0 24 24'
                                                    fill='none'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        fillRule='evenodd'
                                                        clipRule='evenodd'
                                                        d='M3 21V2H1V22C1 22.5523 1.44772 23 2 23H22V21H3Z'
                                                        fill='#9F9F9F'
                                                    />
                                                    <path
                                                        fillRule='evenodd'
                                                        clipRule='evenodd'
                                                        d='M22.7072 6.70718L16.7072 12.7072C16.3167 13.0977 15.6835 13.0977 15.293 12.7072L14.0001 11.4143L9.70718 15.7072C9.31666 16.0977 8.68349 16.0977 8.29297 15.7072L6.00008 13.4143L2.70718 16.7072L1.29297 15.293L5.29297 11.293C5.68349 10.9024 6.31666 10.9024 6.70718 11.293L9.00008 13.5859L13.293 9.29297C13.6835 8.90244 14.3167 8.90244 14.7072 9.29297L16.0001 10.5859L21.293 5.29297L22.7072 6.70718Z'
                                                        fill='#9F9F9F'
                                                    />
                                                </svg>
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='Setting'>
                                        <IconButton
                                            onClick={() => {
                                                setInput(item)
                                                setOpen(true)
                                            }}
                                        >
                                            <SettingsOutlinedIcon
                                                sx={{ color: 'grey' }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            )}
                            <Typography>{item.name}</Typography>
                            <CardContent
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant='h4'>
                                    {/* {device.status === 'Online'
                                        ? typeof item.value === 'number'
                                            ? item.value.toFixed(2)
                                            : Number(item.value).toFixed(2)
                                        : '--'} */}
                                    {device.status === 'Offline'
                                        ? '--'
                                        : !isNaN(item.value) &&
                                          isFinite(item.value)
                                        ? Number(item.value)
                                        : item.value}{' '}
                                    {item.unit}
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                </React.Fragment>
            ))}

            <CustomModal
                size='sm'
                open={open}
                setOpen={setOpen}
                handleClose={() => {
                    setOpen(false)
                    // getDeviceById()
                }}
            >
                <Grid container spacing={1} p={1}>
                    <Grid item xs={12} mt={2}>
                        <Typography variant='h5' gutterBottom>
                            Graph Trend Setting
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    value={input.min_y ?? ''}
                                    onChange={(e) =>
                                        setInput({
                                            ...input,
                                            min_y: e.target.value,
                                        })
                                    }
                                    type='number'
                                    name='min_y'
                                    label='Minimum Y'
                                    size='small'
                                    inputProps={{ min: -99999999 }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    value={input.max_y ?? ''}
                                    onChange={(e) =>
                                        setInput({
                                            ...input,
                                            max_y: e.target.value,
                                        })
                                    }
                                    name='max_y'
                                    label='Maximum Y'
                                    size='small'
                                    inputProps={{ min: -99999999 }}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <ActionButtons
                            canSave={!loading}
                            onSave={handleUpdateLimit}
                            onCancel={() => {
                                setOpen(false)
                                // getDeviceById()
                            }}
                        />
                    </Grid>
                </Grid>
            </CustomModal>
        </React.Fragment>
    )
}
